define('views/modules/calendar/nutrition/entry/food-entry-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/nutrition/food/list/base-food-item',
    // events
    'services/events/nutrition-events',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBaseFoodItem,
    // events
    NutritionEvents
) {

    var VFoodEntryItem = VBaseFoodItem.extend({
      //touchstart -Mandatory for IPAD or click event isn't firing
        events: {
            "click .food-check": "onEatenClick",
            "click .food-delete": "onDeleteClick",
            "touchstart .food-delete": "onDeleteClick",
            "item:move": "onMove",
        },

        initialize: function(opt) {
            this.options = _.extend({ foodCheck: true }, opt);

            var model = this.model,
                food = this.food = model.getFood();

            this.listenTo(model, {
                'remove': this.remove,
                'change:_food': this.render
            });

            this.listenTo(NutritionEvents, {
                "food:toggleAll": this.toggleAll,
            });

            this.listenTo(food, { 'sync': this.render });
        },

        render: function() {
            var data = _.extend(this.getData(), {
                foodImage: this.model.get('full')
            });
            var html = Mustache.render(this.template, Mustache.getContext(data));
            
            this.$el.empty().append(html);
            this.generateZones();

            this.applyBindings();

            return this;
        },

        getData: function() {
            return _.extend(this.getFood().toJSON(), {
                foodCheck: this.options.foodCheck
            });
        },

        getFood: function() {
            return this.food;
        },

        getNutrients: function() {
            var nutrientObj = {};
            return this.model.addNutrientTo(nutrientObj);
        },

        ////////////
        // events //
        ////////////
        onEatenClick: function(value) {
            this.model.toggle('isEaten');
        },
        onDeleteClick: function(e) {
            this.model.trigger('entry:remove', this.model);
        },

        onMove: function(e, context, callback) {
            this.model.trigger("entry:move", this.model);
            callback.call(context, this, this.model);
        },

        toggleAll: function(value) {
            this.model.isEaten(value);
        }
    });

    return VFoodEntryItem;
});

